module.exports = __webpack_public_path__ + "static/media/icon_stamp_summary.a77e4e60.svg";